import Package from '@/models/Package';
import PackageService from '@/services/PackageService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const usePackagesStore = defineStore('packages', {
  state: () => ({}),

  getters: {
    models: () => useRepo(Package),
  },

  actions: {
    async index(projectId: Id, form: ApiRequests['api.v1.packages.index'] = {}) {
      const [data, error] = await PackageService.index(projectId, form);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async show(id: Id) {
      const [data, error] = await PackageService.show(id);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async create(projectId: Id, form: ApiRequests['api.v1.packages.store']) {
      const [data, error] = await PackageService.create(projectId, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async update(id: Id, form: ApiRequests['api.v1.packages.update']) {
      const [data, error] = await PackageService.update(id, form);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async delete(id: Id) {
      const [data, error] = await PackageService.delete(id);

      if(error) {
        throw error;
      }

      this.models.destroy(data.id);

      return data;
    },

    async fetchSubcontractorDashboard(projectId: Id, form: ApiRequests['api.v1.subcontractor.claims.dashboard.index']) {
      const [data, error] = await PackageService.subcontractor.dashboardIndex(projectId, form);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async fetchSubcontractorDashboardShow(projectId: Id, packageId: Id) {
      const [data, error] = await PackageService.subcontractor.dashboardShow(projectId, packageId);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async navbarIndex(projectId: Id) {
      const [data, error] = await PackageService.navbar.index(projectId);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async fetchVariationOrderDashboard(projectId: Id) {
      const [data, error] = await PackageService.variationOrders.dashboardIndex(projectId);

      if(error) {
        throw error;
      }

      this.models.save(data.packages);

      return data as SubcontractVariationOrderDashboard;
    },
  },
});
